import React from 'react';
import { Link, NavLink } from 'react-router-dom';


const NotFoundPage = () => {
  return (
    <main className="not-found-container">
    <h1>Erreur 404</h1>
    <p>Oups, il semble que nous ayons perdu une corde... ou peut-être deux.</p>
    <p>
        En attendant que nos techniciens retrouvent ces cordes égarées, pourquoi ne pas retourner à la{' '}
        <NavLink to="/">page d'accueil</NavLink> et explorer d'autres mélodies ukulélé ?
    </p>

    <p>
        Si vous pensez qu'il y a une erreur, veuillez <NavLink to="/contact">nous contacter</ NavLink> et nous réglerons ça
        rapidement (avant que d'autres cordes ne disparaissent !).
    </p>
</main>
);
};
 

export default NotFoundPage;
